import { createApp } from 'vue'
import App from './App.vue'
import '@/styles/style.scss'

createApp(App).mount('#app')